import React from 'react'
import { KeyboardDatePicker } from '@material-ui/pickers'
import moment from 'moment'

const DatePicker = ({ 
    form,
    field,
    onChange,
    error,
    errorText,
    ...rest
}) => {
    const handleChange= (value) => {
        if (onChange) onChange(value)
        form.setFieldValue(field.name,moment(value).format('YYYY-MM-DD')) 
    }

    return (
        <KeyboardDatePicker
            name={field.name}
            keyboard="true"
            clearable
            autoOk
            value={field.value}
            format="DD-MM-YYYY"
            disableopenonenter="true"
            onChange={handleChange}
            onBlur={()=>form.setFieldTouched(field.name)}
            error={Boolean(error)}
            helperText={errorText}
            {...rest}
        />
    )
}


export default DatePicker
